import { render, staticRenderFns } from "./srticleDetail.vue?vue&type=template&id=41593fc3&scoped=true"
import script from "./srticleDetail.vue?vue&type=script&lang=js"
export * from "./srticleDetail.vue?vue&type=script&lang=js"
import style0 from "./srticleDetail.vue?vue&type=style&index=0&id=41593fc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41593fc3",
  null
  
)

export default component.exports